import { MappedEntity } from '@api/api/entity-schema';
import semanticColorStyles from '@design/styles/SemanticColor.module.scss';
import { PriceStatus } from '@helpers/utils/numbers/numbers';
import { globalPriceFormatter } from '@terminal/utils/asset-price/assetPrice';

export const priceStatusClassMap: Record<PriceStatus, string> = {
  [PriceStatus.Default]: semanticColorStyles.directionNeutralSoft,
  [PriceStatus.Negative]: semanticColorStyles.directionNegative,
  [PriceStatus.Positive]: semanticColorStyles.directionPositive,
};

export const formatPrice = (price: number, entity: MappedEntity) =>
  globalPriceFormatter({
    entity,
    price,
    priceSuffix: '',
    shouldShowCurrency: false,
  });
